import { Messages } from '../../codegen/Localize';
import {
  ActionHelpers,
  standardActionErrorMsg,
  standardActionSuccessMsg,
  StandardActionToastMessages
} from '../../commonInfra/contentActions/ActionHelpers';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { ISchedule } from '../../schedule/types/ISchedule';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Schedules } from '../resources/Schedules';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { ScheduleErrorsService } from './ScheduleErrors';


export class SetScheduleStatusAction {

  public static $inject = ['ConfirmActionDialog',  'Schedules'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private Schedules: Schedules) { }

  public enableSchedule(schedule: ISchedule): ng.IPromise<void> {
    return this.enableSchedules(this.singleton(schedule));
  }

  public disableSchedule(schedule: ISchedule): ng.IPromise<void> {
    return this.disableSchedules(this.singleton(schedule));
  }

  private singleton(schedule: ISchedule): Set<ISchedule> {
    return Set.singleton(schedule, (s: ISchedule) => s.id);
  }

  public confirmEnableSchedules(schedules: Set<ISchedule>, context: IActionContext): ng.IPromise<IResult> {
    const dialogText = schedules.size() === 1
      ? Messages.enableScheduleDialogPrompt({ NAME: schedules.getByIndex(0).name })
      : Messages.enableSchedulesDialogPrompt({ ITEM_COUNT_LOC: L10n.localizedCount(schedules.size()) });
    const actionName = schedules.size() === 1
      ? Messages.enableScheduleDialogSubmit()
      : Messages.enableSchedulesDialogSubmit({ ITEM_COUNT_LOC: L10n.localizedCount(schedules.size()) });
    return this.confirmAction(
      context,
      () => this.enableSchedules(schedules),
      Messages.enableSchedulesDialogTitle(),
      dialogText,
      actionName,
      );
  }

  public confirmDisableSchedules(schedules: Set<ISchedule>, context: IActionContext): ng.IPromise<IResult> {
    const dialogText = schedules.size() === 1
      ? Messages.disableScheduleDialogPrompt({ NAME: schedules.getByIndex(0).name })
      : Messages.disableSchedulesDialogPrompt({ ITEM_COUNT_LOC: L10n.localizedCount(schedules.size()) });
    const actionName = schedules.size() === 1
      ? Messages.disableScheduleDialogSubmit()
      : Messages.disableSchedulesDialogSubmit({ ITEM_COUNT_LOC: L10n.localizedCount(schedules.size()) });
    return this.confirmAction(
      context,
      () => this.disableSchedules(schedules),
      Messages.disableSchedulesDialogTitle(),
      dialogText,
      actionName,
    );
  }

  private confirmAction(
      context: IActionContext,
      action: () => ng.IPromise<void>,
      title: string,
      bodyText: string,
      actionName: string,
    ) {

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title,
      bodyText,
      actionName,
      action: action
    }).result;
  }

  private enableSchedules(schedules: Set<ISchedule>): ng.IPromise<void> {
    const translations: StandardActionToastMessages = {
      error: standardActionErrorMsg(Messages.enableSchedulesError),
      success: standardActionSuccessMsg(Messages.enableSchedulesSuccess),
    };

    return this.Schedules.enable(schedules.keys())
      .then((result: IResult) =>
        this.notifyResult(schedules, result, translations));
  }

  private disableSchedules(schedules: Set<ISchedule>): ng.IPromise<void> {
    const translations: StandardActionToastMessages = {
      error: standardActionErrorMsg(Messages.disableSchedulesError),
      success: standardActionSuccessMsg(Messages.disableSchedulesSuccess),
    };

    return this.Schedules.disable(schedules.keys())
      .then((result: IResult) =>
        this.notifyResult(schedules, result, translations));
  }

  private notifyResult(schedules: Set<ISchedule>, result: IResult, translations: StandardActionToastMessages) {
    ActionHelpers.displayStandardToastsForResult(
      schedules,
      result,
      translations,
      (errorItem: IErrorItem<ISchedule>) => ScheduleErrorsService.errorDetailsFor(errorItem));
  }

}

Module.instance().service('SetScheduleStatusAction', SetScheduleStatusAction);
